import get from 'lodash/get';
import { createSelector } from 'reselect';
import { RootState } from 'store/types';
import { DetailDownloadState, PaymentDownloadState } from './reducers';

export const detailDownloadSelector = (state: RootState) => state.billing.detailsDownload;
export const detailDownloadFetchingSelector = createSelector(
  detailDownloadSelector,
  (detailsDownload: DetailDownloadState) => detailsDownload.isFetching
);
export const detailDownloadDataSelector = createSelector(
  detailDownloadSelector,
  (detailsDownload: DetailDownloadState) => detailsDownload.data
);

export const paymentDownloadSelector = (state: RootState) => state.billing.paymentsDownload;

export const paymentDownloadFetchingSelector = createSelector(
  paymentDownloadSelector,
  (paymentsDownload: PaymentDownloadState) => paymentsDownload.isFetching
);
export const paymentDownloadDataSelector = createSelector(
  paymentDownloadSelector,
  (paymentsDownload: PaymentDownloadState) => paymentsDownload.data
);
export const getPaymentDetailDataSelector = (state: RootState) =>
  get(state, 'billing.paymentDetail.data');

export const getPaymentDetailFetchingSelector = (state: RootState) =>
  get(state, 'billing.paymentDetail.isFetching');

export const getPaymentDetailErrorSelector = (state: RootState) =>
  get(state, 'billing.paymentDetail.error');

export const getEncounterDetailDataSelector = (state: RootState) =>
  get(state, 'billing.encounterDetail.data');

export const getEncounterDetailFetchingSelector = (state: RootState) =>
  get(state, 'billing.encounterDetail.isFetching');

export const getEncounterDetailErrorSelector = (state: RootState) =>
  get(state, 'billing.encounterDetail.error');
